"use client";

import { useRef, useState } from "react";
import type { StripeError } from "@stripe/stripe-js";

type PaymentElementStatus = "loading" | "ready" | "error";

export function usePaymentElementStatus() {
  const [status, setStatus] = useState<PaymentElementStatus>("loading");
  const hasReportedLoadError = useRef(false);

  const handleReady = () => setStatus("ready");
  const handleLoadError = (event: {
    elementType: "payment";
    error: StripeError;
  }) => {
    setStatus("error");

    if (hasReportedLoadError.current) {
      return;
    }

    hasReportedLoadError.current = true;
    void import("~/lib/monitoring/client").then(
      ({ logger }) => {
        logger.error("Stripe Payment Element failed to load", {
          feature_area: "payment",
          stripe_error_code: event.error.code,
          stripe_error_type: event.error.type,
        });
      },
      () => undefined,
    );
  };

  return { handleLoadError, handleReady, status };
}
